import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { CheckTemplateRollsProfileResData } from "./CheckTemplateRollsProfileResData";

const ENDPOINT = "/security/templates/checkprofile";

export class CheckTemplateRollsProfileCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: CheckTemplateRollsProfileReqData = null;

    constructor(templateId: number, installationsNames: string[]) {
        super();
        this.payload = new CheckTemplateRollsProfileReqData(templateId, installationsNames);
    }

    public async execute(): Promise<CheckTemplateRollsProfileResData> {
        let res = await this.executeCommand(this.payload);
        return new CheckTemplateRollsProfileResData(res);
    }
}

export class CheckTemplateRollsProfileReqData {
    templateId: number;
    installationsNames: Array<string>;

    constructor(templateId: number, installationsNames: string[]) {
        this.templateId = templateId;
        this.installationsNames = installationsNames;
    }
}
